/* Southern Grown — small progressive enhancements. Everything works without it. */
(() => {
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };

  /* Header: measure the announcement bar; on home, go solid once the visitor scrolls */
  const wrap = document.querySelector('[data-sg-header]');
  if (wrap) {
    const bar = wrap.querySelector('[data-sg-announce]');
    const setBar = () => document.documentElement.style.setProperty('--sg-announce-h', (bar ? bar.offsetHeight : 0) + 'px');
    setBar();
    window.addEventListener('resize', setBar);
    const header = wrap.querySelector('.sg-header');
    let lastY = window.scrollY, ticking = false, limit = 120;
    const measure = () => { limit = header ? header.offsetHeight + (bar ? bar.offsetHeight : 0) : 120; };
    const update = () => {
      ticking = false;
      const y = window.scrollY;
      const past = y > limit;
      if (wrap.classList.contains('is-scrolled') !== past) wrap.classList.toggle('is-scrolled', past);
      if (Math.abs(y - lastY) > 6) {
        const hide = past && y > lastY && !(document.querySelector('[data-sg-drawer].is-open')) && !wrap.contains(document.activeElement);
        if (wrap.classList.contains('is-hidden') !== hide) wrap.classList.toggle('is-hidden', hide);
        lastY = y;
      }
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    measure();
    update();
    addEventListener('resize', measure);
    window.addEventListener('scroll', onScroll, { passive: true });

    /* Mobile menu */
    const drawer = wrap.querySelector('[data-sg-drawer]');
    const openBtn = wrap.querySelector('[data-sg-menu-open]');
    const close = () => { drawer.classList.remove('is-open'); openBtn.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; openBtn.focus(); };
    if (drawer && openBtn) {
      openBtn.addEventListener('click', () => { drawer.classList.add('is-open'); openBtn.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; drawer.querySelector('[data-sg-menu-close]').focus(); });
      drawer.querySelector('[data-sg-menu-close]').addEventListener('click', close);
      drawer.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); else sgTrapTab(drawer, e); });
    }
  }

  /* Sign-up popup: 50% scroll or 20s, never on first paint; 30 days after dismissal, never after sign-up */
  const pop = document.body.classList.contains('template-product') ? null : document.querySelector('[data-sg-popup]');
  if (pop) {
    const posted = /customer_posted=true/.test(location.search) && location.hash === '#sg-pop';
    const DAY = 864e5;
    const dismissed = Number(store.get('sg-pop-dismissed') || 0);
    const signedUp = store.get('sg-pop-done') === '1';
    let lastFocus = null;
    const open = () => {
      if (!pop.hidden) return;
      lastFocus = document.activeElement;
      pop.hidden = false; pop.classList.add('is-open');
      sgPlayLoops(pop);
      (matchMedia('(hover: none)').matches ? pop.querySelector('[data-sg-popup-close]') : (pop.querySelector('input[type=email]') || pop.querySelector('[data-sg-popup-close]'))).focus();
    };
    const shut = () => {
      pop.classList.remove('is-open');
      setTimeout(() => { if (!pop.classList.contains('is-open')) pop.hidden = true; }, 220); /* after the exit fade */
      pop.querySelectorAll('video[data-sg-loop]').forEach((v) => v.pause());
      if (!posted) store.set('sg-pop-dismissed', String(Date.now()));
      if (lastFocus) lastFocus.focus();
    };
    pop.querySelectorAll('[data-sg-popup-close]').forEach((b) => b.addEventListener('click', shut));
    pop.addEventListener('keydown', (e) => { if (e.key === 'Escape') shut(); else sgTrapTab(pop, e); });
    pop.querySelector('form') && pop.querySelector('form').addEventListener('submit', () => store.set('sg-pop-done', '1'));
    if (posted) { store.set('sg-pop-done', '1'); open(); }
    else if (!signedUp && Date.now() - dismissed > 30 * DAY) {
      const t = setTimeout(open, 20000);
      let busy = false;
      const onScroll = () => {
        if (busy) return;
        busy = true;
        requestAnimationFrame(() => {
          busy = false;
          const h = document.documentElement.scrollHeight - innerHeight;
          if (h > 0 && scrollY / h >= 0.5) { clearTimeout(t); removeEventListener('scroll', onScroll); open(); }
        });
      };
      addEventListener('scroll', onScroll, { passive: true });
    }
  }

  /* Gallery: dots and arrows follow the swipe */
  document.querySelectorAll('[data-sg-gallery]').forEach((g) => {
    const track = g.querySelector('.sg-gallery__track');
    const dots = [...g.querySelectorAll('.sg-dots button')];
    const n = track.children.length;
    const go = (i) => track.scrollTo({ left: ((i + n) % n) * track.clientWidth, behavior: 'smooth' });
    const cur = () => Math.round(track.scrollLeft / track.clientWidth);
    dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
    g.querySelector('[data-prev]')?.addEventListener('click', () => go(cur() - 1));
    g.querySelector('[data-next]')?.addEventListener('click', () => go(cur() + 1));
    track.addEventListener('scroll', () => { const i = cur(); dots.forEach((d, j) => d.setAttribute('aria-current', i === j ? 'true' : 'false')); }, { passive: true });
  });

  /* Size pills: keep the variant id, price and button in step */
  document.querySelectorAll('[data-sg-buy]').forEach((f) => {
    const id = f.querySelector('input[name=id]');
    const price = (f.closest('[data-sg-scope]') || f).querySelector('[data-sg-price]');
    const btn = f.querySelector('[type=submit]');
    const qty = f.querySelector('input[name=quantity]');
    const label = (btn && btn.dataset.label) || 'Add to cart';
    const withTotal = btn && btn.hasAttribute('data-total');
    const sync = () => {
      const r = f.querySelector('[data-variant]:checked');
      if (!r) return;
      id.value = r.dataset.variant;
      const min = Number(r.dataset.min) || 1, step = Number(r.dataset.step) || 1;
      if (qty) {
        let v = parseInt(qty.value, 10) || min;
        if (qty.hasAttribute('data-sg-qty-hidden')) v = min;
        v = Math.max(min, Math.ceil(v / step) * step);
        qty.value = v; qty.min = min; qty.step = step;
        const minus = f.querySelector('[data-qty="-1"]'); if (minus) minus.disabled = v <= min;
      }
      const note = f.querySelector('[data-sg-case]');
      if (note) { note.hidden = step <= 1; note.querySelectorAll('span').forEach((s) => { s.textContent = step; }); }
      const q = qty ? parseInt(qty.value, 10) || 1 : 1;
      if (price) price.textContent = r.dataset.price;
      if (btn) {
        btn.disabled = r.dataset.available !== 'true';
        (btn.querySelector('[data-sg-label]') || btn).textContent = btn.disabled ? 'Sold out' : (withTotal ? label + ' · ' + formatMoney(r.dataset.cents * q, r.dataset.price) : label);
      }
    };
    f.addEventListener('change', sync);
    f.querySelectorAll('[data-qty]').forEach((b) => b.addEventListener('click', () => {
      const step = Number(qty.step) || 1, min = Number(qty.min) || 1;
      qty.value = Math.max(min, (parseInt(qty.value, 10) || min) + Number(b.dataset.qty) * step);
      sync();
    }));
    sync();
  });
  /* Trade order: order in cases, live totals, add every row in one go */
  document.querySelectorAll('[data-sg-trade]').forEach((f) => {
    const msg = f.querySelector('[data-sg-trade-msg]');
    const submit = f.querySelector('[data-sg-trade-submit]');
    const totalEl = f.querySelector('[data-sg-trade-total]');
    const countEl = f.querySelector('[data-sg-trade-count]');
    const sample = (f.querySelector('.sg-trade__each') || { textContent: '$' }).textContent;
    const rows = [...f.querySelectorAll('[data-row]')].map((row) => {
      const input = row.querySelector('input[data-variant]');
      return input ? { row, input, step: Number(row.dataset.step) || 1, cents: Number(row.dataset.cents) || 0, minus: row.querySelector('[data-case="-1"]'), plus: row.querySelector('[data-case="1"]'), line: row.querySelector('[data-line]') } : null;
    }).filter(Boolean);
    /* Quantities are in packs; they snap up to whole cases and the catalog minimum */
    const clamp = (r, packs) => {
      const minP = (Number(r.input.dataset.mincases) || 1) * r.step;
      const maxP = r.input.dataset.maxcases ? Number(r.input.dataset.maxcases) * r.step : Infinity;
      let n = Math.max(0, parseInt(packs, 10) || 0);
      if (n > 0) n = Math.max(minP, Math.ceil(n / r.step) * r.step);
      return Math.min(n, maxP);
    };
    const sync = () => {
      let packs = 0, cents = 0;
      rows.forEach((r) => {
        const n = Number(r.input.value) || 0;
        const cases = Math.ceil(n / r.step);
        r.row.classList.toggle('is-active', n > 0);
        r.minus.disabled = n <= 0;
        r.line.textContent = n > 0 ? (r.step > 1 ? cases + (cases === 1 ? ' case' : ' cases') + ' · ' : '') + formatMoney(n * r.cents, sample) : '';
        packs += n; cents += n * r.cents;
      });
      totalEl.textContent = formatMoney(cents, sample);
      countEl.textContent = packs ? packs + (packs === 1 ? ' pack' : ' packs') : 'Nothing added yet';
      submit.disabled = !packs;
      msg.classList.remove('sg-form-msg--error');
      msg.textContent = '';
    };
    rows.forEach((r) => {
      const minP = (Number(r.input.dataset.mincases) || 1) * r.step;
      r.input.addEventListener('input', sync); /* totals follow typing; rounding to whole cases happens when the field is left */
      r.input.addEventListener('change', () => { r.input.value = clamp(r, r.input.value); sync(); });
      r.minus.addEventListener('click', () => { const n = Number(r.input.value) || 0; r.input.value = n - r.step < minP ? 0 : clamp(r, n - r.step); sync(); });
      r.plus.addEventListener('click', () => { const n = Number(r.input.value) || 0; r.input.value = clamp(r, n === 0 ? minP : n + r.step); sync(); });
    });
    sync();
    f.addEventListener('submit', async (e) => {
      e.preventDefault();
      rows.forEach((r) => { r.input.value = clamp(r, r.input.value); });
      const items = rows.map((r) => ({ id: Number(r.input.dataset.variant), quantity: Number(r.input.value) || 0 })).filter((i) => i.quantity > 0);
      msg.classList.remove('sg-form-msg--error');
      if (!items.length) { msg.textContent = 'Add some packs first.'; msg.classList.add('sg-form-msg--error'); return; }
      submit.disabled = true;
      msg.textContent = 'Adding to your order…';
      try {
        /* Packs already in the cart (e.g. a retail pack added before logging in) count toward the case rule,
           so set each line to whole cases already there plus this order, rather than adding on top */
        const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
        const cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
        const updates = {};
        items.forEach((i) => {
          const row = rows.find((x) => Number(x.input.dataset.variant) === i.id);
          const have = cart.items.filter((l) => l.variant_id === i.id).reduce((n, l) => n + l.quantity, 0);
          updates[i.id] = Math.floor(have / row.step) * row.step + i.quantity;
        });
        const r = await fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) });
        const j = await r.json();
        if (!r.ok) throw new Error(j.description || j.message || 'error');
        location.href = '/cart';
      } catch (err) { console.error('Trade order:', err); msg.textContent = 'Unable to add the order. Check the quantities and try again' + (f.dataset.sgEmail ? ', or email ' + f.dataset.sgEmail + '.' : '.'); msg.classList.add('sg-form-msg--error'); submit.disabled = false; }
    });
  });

  /* Shop on phones: the two packs swipe sideways; dots follow and can be tapped */
  document.querySelectorAll('[data-sg-duo]').forEach((box) => {
    const track = box.querySelector('[data-sg-duo-track]');
    const dots = [...box.querySelectorAll('[data-sg-duo-dot]')];
    const cards = [...track.children];
    if (!dots.length || cards.length < 2) return;
    const set = () => { const i = track.scrollLeft > (track.scrollWidth - track.clientWidth) / 2 ? 1 : 0; dots.forEach((d, j) => d.setAttribute('aria-current', i === j ? 'true' : 'false')); };
    track.addEventListener('scroll', set, { passive: true });
    dots.forEach((d, i) => d.addEventListener('click', () => track.scrollTo({ left: cards[i].offsetLeft - cards[0].offsetLeft, behavior: 'smooth' })));
    set();
  });

  /* Process line: curved arrows between stage markers, drawn in as you scroll */
  document.querySelectorAll('[data-sg-process]').forEach((sec) => {
    const track = sec.querySelector('.sg-process__track');
    const g = sec.querySelector('[data-sg-paths]');
    const nodes = [...sec.querySelectorAll('[data-sg-node]')];
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    let segs = [];
    const build = () => {
      const t = track.getBoundingClientRect();
      g.innerHTML = '';
      segs = [];
      const narrow = innerWidth < 750;
      const addLine = (d, top, bottom) => {
        const p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        p.setAttribute('d', d);
        if (reduce) p.setAttribute('marker-end', g.dataset.marker);
        g.appendChild(p);
        const len = p.getTotalLength();
        if (!reduce) { p.style.strokeDasharray = len; p.style.strokeDashoffset = len; }
        segs.push({ p, len, top, bottom, last: -1, head: false });
      };
      /* Lead-in: on wider screens one line arrives at the heading and stops; a new one leaves from under it and runs to step 1 */
      if (sec.hasAttribute('data-sg-lead') && nodes[0]) {
        const s = sec.getBoundingClientRect(), n = nodes[0].getBoundingClientRect(), intro = sec.querySelector('.sg-process__intro').getBoundingClientRect();
        const x1 = n.left + n.width / 2 - t.left, y1 = n.top - t.top - 12;
        const yIn = intro.top - t.top - 14, yOut = intro.bottom - t.top + 14;
        if (narrow) {
          addLine(`M${x1},${yOut} L${x1},${y1}`, intro.bottom + scrollY, n.top + scrollY); /* phones: the intro spans the width, so start under it */
        } else {
          /* Optionally start one section higher, down the gap between that section's text and photo */
          const prev = sec.hasAttribute('data-sg-lead-prev') && sec.closest('.shopify-section') && sec.closest('.shopify-section').previousElementSibling;
          const split = prev && prev.querySelector('.sg-split');
          let d, startTop = s.top;
          if (split && split.children.length === 2) {
            const [c1, c2] = [...split.children].map((c) => c.getBoundingClientRect()).sort((p, q) => p.left - q.left);
            const gx = (c1.right + c2.left) / 2 - t.left, ys = prev.getBoundingClientRect().top - t.top, ye = Math.max(c1.bottom, c2.bottom) - t.top + 8, h = yIn - ye;
            startTop = prev.getBoundingClientRect().top;
            d = `M${gx},${ys} L${gx},${ye} C${gx},${ye + h * 0.6} ${x1},${yIn - h * 0.6} ${x1},${yIn}`;
          } else {
            d = `M${x1},${s.top - t.top} L${x1},${yIn}`;
          }
          addLine(d, startTop + scrollY, intro.top + scrollY);
          const h2 = y1 - yOut;
          addLine(`M${x1},${yOut} C${x1 + 60},${yOut + h2 * 0.35} ${x1 - 60},${y1 - h2 * 0.35} ${x1},${y1}`, intro.bottom + scrollY, n.top + scrollY);
        }
      }
      for (let i = 0; i < nodes.length - 1; i++) {
        const a = nodes[i].getBoundingClientRect(), b = nodes[i + 1].getBoundingClientRect();
        const x0 = a.left + a.width / 2 - t.left, y0 = a.bottom - t.top + 10;
        const x1 = b.left + b.width / 2 - t.left, y1 = b.top - t.top - 12;
        const swing = (narrow ? 22 : 150) * (i % 2 ? -1 : 1);
        const h = y1 - y0;
        const d = `M${x0},${y0} C${x0 + swing},${y0 + h * 0.35} ${x1 - swing},${y1 - h * 0.35} ${x1},${y1}`;
        addLine(d, a.bottom + scrollY, b.top + scrollY);
      }
      /* Each line starts drawing the moment the one before it finishes, with no pause at a heading or marker */
      segs.forEach((s, i) => { if (i) { const q = segs[i - 1]; s.top = q.top + (q.bottom - q.top) * 0.97; } });
      draw();
    };
    let ticking = false;
    const draw = () => {
      ticking = false;
      if (reduce) return;
      const line = scrollY + innerHeight * 0.7;
      segs.forEach((s) => {
        let prog = Math.min(1, Math.max(0, (line - s.top) / Math.max(1, s.bottom - s.top)));
        if (prog > 0.97) prog = 1; /* finish the line before the arrowhead shows, so they join */
        prog = Math.round(prog * 400) / 400;
        if (prog !== s.last) { s.p.style.strokeDashoffset = s.len * (1 - prog); s.last = prog; }
        const head = prog === 1;
        if (head !== s.head) { if (head) s.p.setAttribute('marker-end', g.dataset.marker); else s.p.removeAttribute('marker-end'); s.head = head; }
      });
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(draw); } };
    build();
    addEventListener('resize', build);
    addEventListener('load', build);
    addEventListener('scroll', onScroll, { passive: true });
    if ('ResizeObserver' in window) { let rt; new ResizeObserver(() => { clearTimeout(rt); rt = setTimeout(build, 120); }).observe(track); }
    sec.querySelectorAll('img').forEach((im) => im.addEventListener('load', build, { once: true }));
    /* Real clips play only while on screen */
    const vids = sec.querySelectorAll('video[data-sg-autoplay]');
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting && !reduce && !e.target.dataset.sgUserPaused) { e.target.preload = 'auto'; e.target.play().catch(() => {}); } else e.target.pause(); }), { threshold: 0.25 });
      vids.forEach((v) => io.observe(v));
    }
  });

  /* Gifting dropdown: click/keyboard toggle, closes on outside click or Escape */
  document.querySelectorAll('[data-sg-drop]').forEach((d) => {
    const btn = d.querySelector('button');
    const set = (open) => { d.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', String(open)); };
    btn.addEventListener('click', () => set(!d.classList.contains('is-open')));
    d.addEventListener('keydown', (e) => { if (e.key === 'Escape') { set(false); btn.focus(); } });
    d.addEventListener('focusout', (e) => { if (!d.contains(e.relatedTarget)) set(false); });
    document.addEventListener('click', (e) => { if (!d.contains(e.target)) set(false); });
  });

  /* Product page: sticky add-to-cart on mobile once the main button scrolls away */
  const sticky = document.querySelector('[data-sg-sticky]');
  const buy = document.querySelector('.sg-buy [data-sg-buy]');
  if (sticky && buy && 'IntersectionObserver' in window) {
    const mainBtn = buy.querySelector('[type=submit]');
    const stickyBtn = sticky.querySelector('[data-sg-sticky-add]');
    const stickyPrice = sticky.querySelector('[data-sg-sticky-price]');
    const scopePrice = buy.closest('[data-sg-scope]') && buy.closest('[data-sg-scope]').querySelector('[data-sg-price]');
    const sync = () => { if (scopePrice) stickyPrice.textContent = scopePrice.textContent; stickyBtn.disabled = mainBtn.disabled; stickyBtn.textContent = mainBtn.disabled ? 'Sold out' : 'Add to cart'; };
    buy.addEventListener('change', () => setTimeout(sync, 0));
    stickyBtn.addEventListener('click', () => { if (buy.requestSubmit) buy.requestSubmit(mainBtn); else mainBtn.click(); });
    new IntersectionObserver(([e]) => {
      const on = !e.isIntersecting;
      sticky.classList.toggle('is-on', on);
      sticky.setAttribute('aria-hidden', String(!on));
      stickyBtn.tabIndex = on ? 0 : -1;
    }).observe(mainBtn);
    sync();
  }

  /* Cart note re-renders when Dawn updates the cart */
  const note = document.querySelector('[data-sg-cart-note]');
  if (note && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    const sid = note.closest('.shopify-section') && note.closest('.shopify-section').id.replace('shopify-section-', '');
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      fetch(location.pathname + '?section_id=' + sid).then((r) => r.text()).then((html) => {
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-sg-cart-note]');
        if (!fresh) return;
        const typed = note.querySelector('[data-sg-gift-msg]');
        const keep = typed ? typed.value : null;
        note.innerHTML = fresh.innerHTML;
        const box = note.querySelector('[data-sg-gift-msg]');
        if (box && keep !== null) box.value = keep;
      }).catch(() => {});
    });
  }

  /* Cart: gift message saves as the order note; the card checkbox adds or removes the $4 card */
  if (note) {
    let saveTimer;
    const saveNote = (value) => fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/update.js' : '/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: value })
    }).catch(() => {});
    note.addEventListener('input', (e) => {
      const box = e.target.closest('[data-sg-gift-msg]');
      if (!box) return;
      const count = note.querySelector('[data-sg-gift-count]');
      if (count) count.textContent = box.value.length;
      clearTimeout(saveTimer);
      saveTimer = setTimeout(() => saveNote(box.value), 600);
    });
    note.addEventListener('change', (e) => {
      const cb = e.target.closest('[data-sg-gift-card]');
      if (!cb) return;
      const wrap = cb.closest('.sg-gift__check');
      if (wrap) wrap.classList.add('is-busy');
      const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
      const box = note.querySelector('[data-sg-gift-msg]');
      clearTimeout(saveTimer);
      const id = Number(cb.dataset.variant);
      (box ? saveNote(box.value) : Promise.resolve())
        .then(() => fetch(root + (cb.checked ? 'cart/add.js' : 'cart/change.js'), {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(cb.checked ? { items: [{ id, quantity: 1 }] } : { id: String(id), quantity: 0 })
        }))
        .then(() => location.reload())
        .catch(() => { cb.checked = !cb.checked; if (wrap) wrap.classList.remove('is-busy'); });
    });
  }
  function formatMoney(cents, sample) {
    const sym = (sample.match(/^[^\d]*/) || ['$'])[0];
    return sym + (cents / 100).toFixed(2);
  }
})();

/* Keep Tab inside an open modal (menu drawer, sign-up popup) */
function sgTrapTab(box, e) {
  if (e.key !== 'Tab') return;
  const f = [...box.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type=hidden]), textarea, select, [tabindex]:not([tabindex="-1"])')].filter((el) => el.offsetParent !== null);
  if (!f.length) return;
  const first = f[0], last = f[f.length - 1];
  if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
  else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
}

/* Looping animations: play only when visible (skips the hidden mobile popup panel) and never for reduced motion */
function sgPlayLoops(root) {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  root.querySelectorAll('video[data-sg-loop]').forEach((v) => { if (v.offsetParent !== null && !v.dataset.sgUserPaused) v.play().catch(() => {}); });
}
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.sg-404__loop').forEach((el) => sgPlayLoops(el));
});
if (document.readyState !== 'loading') document.querySelectorAll('.sg-404__loop').forEach((el) => sgPlayLoops(el));

/* Looping videos: a visible pause/play control. A pause by the visitor sticks; nothing restarts that video. */
function sgVideoControls() {
  document.querySelectorAll('[data-sg-vidctl]').forEach((b) => {
    const v = b.parentElement.querySelector('video');
    if (!v || b.dataset.sgReady) return;
    b.dataset.sgReady = '1';
    const set = () => { b.toggleAttribute('data-paused', v.paused); b.setAttribute('aria-label', v.paused ? 'Play video' : 'Pause video'); };
    v.addEventListener('play', set); v.addEventListener('pause', set); set();
    b.addEventListener('click', () => { if (v.paused) { delete v.dataset.sgUserPaused; v.play().catch(() => {}); } else { v.dataset.sgUserPaused = '1'; v.pause(); } });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sgVideoControls); else sgVideoControls();

/* Lenis smooth scroll: wheel and trackpad only (touch stays native). Off for reduced motion and in the theme editor. */
(() => {
  if (typeof Lenis === 'undefined' || matchMedia('(prefers-reduced-motion: reduce)').matches || (window.Shopify && Shopify.designMode)) return;
  const lenis = new Lenis({
    autoRaf: true,
    lerp: 0.1,
    anchors: { offset: -96 },
    allowNestedScroll: true,
    prevent: (node) => !!node.closest('[data-sg-popup], [data-sg-drawer], [class*="jdgm-modal"], [class*="jm-modal"], .drawer, cart-drawer, [role="dialog"]')
  });
  window.sgLenis = lenis;
  /* Pause while anything locks the page (our menu, Dawn drawers, the Judge.me review form) */
  const sync = () => {
    const locked = getComputedStyle(document.body).overflow === 'hidden' || document.documentElement.style.overflow === 'hidden';
    if (locked && !lenis.isStopped) lenis.stop();
    else if (!locked && lenis.isStopped) lenis.start();
  };
  const watch = { attributes: true, attributeFilter: ['style', 'class'] };
  new MutationObserver(sync).observe(document.body, watch);
  new MutationObserver(sync).observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });
})();
